import { CSSProperties } from 'react';

export const PreventUserSelect: CSSProperties = {
  userSelect: 'none',
  'WebkitUserSelect': 'none',
  'msUserSelect': 'none',
  'MozUserSelect': 'none'
};

export const Elided: React.CSSProperties = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
};
